import { CancelRounded, CheckCircleRounded, DeleteRounded } from '@mui/icons-material'
import CancelButtonForm from '../buttons/CancelButton'
import DeleteButtonForm from '../buttons/DeleteButton'
import SaveButtonForm from '../buttons/SaveButton'
import BrandAutocompleteForm from './BrandAutocomplete'
import BrandMultiAutocompleteForm from './BrandMultiAutocomplete'
import CountryAutocompleteForm from './CountryAutocomplete'
import CountryMultiAutocompleteForm from './CountryMultiAutocomplete'
import CustomTextFieldForm from './CustomTextField'
import DatePickerForm from './CustomDatePicker'
import DropzoneForm, { RemoveContent as RemoveContentForm } from './Dropzone'
import DropzoneMultiForm from './DropzoneMulti'
import InputCountryForm from './InputCountry'
import LanguageAutocompleteForm from './LanguageAutocomplete'
import LanguageMultiAutocompleteForm from './LanguageMultiAutocomplete'
import LineAutocompleteForm from './LineAutocomplete'
import PostalcodeAutocompleteForm from './PostalcodeAutocomplete'
import ProvinceAutocompleteForm from './ProvinceAutocomplete'
import ResourcecategoryAutocompleteForm from './ResourcecategoryAutocomplete'
import ResourcetypeSelectForm from './ResourcetypeSelect'
import ResourceTypeMultiAutocompleteForm from './ResourceTypeMultiAutocomplete'
import RoleAutocompleteForm from './RoleAutocomplete'
import StatusAutocompleteForm from './StatusAutocomplete'
import StrongPasswordForm, { StrongPasswordProps } from './StrongPassword'
import TownAutocompleteForm from './TownAutocomplete'
import VisibilityAutocompleteForm from './VisibilityAutocomplete'
import ColorPickerForm from './ColorPicker'
import DateTimePickerForm from './DateTimePicker'

export const BrandAutocomplete = (props: any) => <BrandAutocompleteForm {...props} />
export const BrandMultiAutocomplete = (props: any) => <BrandMultiAutocompleteForm {...props} />
export const CountryMultiAutocomplete = (props: any) => <CountryMultiAutocompleteForm {...props} />
export const InputCountry = (props: any) => <InputCountryForm {...props} />
export const LineAutocomplete = (props: any) => <LineAutocompleteForm {...props} />
export const RoleAutocomplete = (props: any) => <RoleAutocompleteForm {...props} />
export const VisibilityAutocomplete = (props: any) => <VisibilityAutocompleteForm {...props} />
export const ResourcetypeSelect = (props: any) => <ResourcetypeSelectForm {...props} />
export const ResourceTypeMultiAutocomplete = (props: any) => <ResourceTypeMultiAutocompleteForm {...props} />
export const LanguageAutocomplete = (props: any) => <LanguageAutocompleteForm {...props} />
export const LanguageMultiAutocomplete = (props: any) => <LanguageMultiAutocompleteForm {...props} />
export const ResourcecategoryAutocomplete = (props: any) => <ResourcecategoryAutocompleteForm {...props} />
export const DropzoneMulti = (props: any) => <DropzoneMultiForm {...props} />
export const RemoveContent = (props: any) => <RemoveContentForm {...props} />
export const Dropzone = (props: any) => <DropzoneForm {...props} />
export const StrongPassword = ({ password, property, handleInputChange }: StrongPasswordProps) => (
  <StrongPasswordForm password={password} property={property} handleInputChange={handleInputChange} />
)
export const StatusAutocomplete = (props: any) => <StatusAutocompleteForm {...props} />
export const DatePicker = (props: any) => <DatePickerForm {...props} />
export const SaveButton = (props: any) => <SaveButtonForm startIcon={<CheckCircleRounded />} {...props} />
export const CancelButton = (props: any) => <CancelButtonForm startIcon={<CancelRounded />} {...props} />
export const DeleteButton = (props: any) => <DeleteButtonForm startIcon={<DeleteRounded />} {...props} />
export const CountryAutocomplete = (props: any) => <CountryAutocompleteForm {...props} />
export const ProvinceAutocomplete = (props: any) => <ProvinceAutocompleteForm {...props} />
export const TownAutocomplete = (props: any) => <TownAutocompleteForm {...props} />
export const PostalcodeAutocomplete = (props: any) => <PostalcodeAutocompleteForm {...props} />
export const CustomTextField = (props: any) => <CustomTextFieldForm {...props} />
export const ColorPicker = (props: any) => <ColorPickerForm {...props} />
export const DateTimePicker = (props: any) => <DateTimePickerForm {...props} />
